<template>
      <v-layout row wrap justify-center align-center>
          <v-flex xs12>
              <v-card class='mb-2'>
                  <v-card-title class="text-xs-center" style="font-size: 2rem">
                    Cadastro de unidades
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap justify-center align-center>
                      <v-container fluid>
                        <v-form v-model="valid" ref="form" lazy-validation >
                          <v-flex xs12>
                            <v-text-field
                            label="*Nome"
                            v-model="unidadeData.name"
                            :rules="[v => !!v || 'Nome é obrigatório']"
                            :counter="100"
                            maxlength="100"
                            required
                            ></v-text-field>
                            <v-autocomplete 
                              label="*Empresa"
                              :items="empresa"
                              item-text="name"
                              item-value="id"
                              autocomplete
                              required
                              v-model="unidadeData.company"
                              max-height="400"
                              hint="Escolha para qual empresa a unidade pertence."
                            ></v-autocomplete>
                            <v-select
                            :rules="[v => !!v || 'Tipo é obrigatório']"
                            label="*Tipo de estabelecimento"
                            :items="tipolugar"
                            max-height="400"
                            v-model="unidadeData.tipo_readable"
                          ></v-select>
                            <v-text-field
                              label="CEP"
                              v-model="unidadeData.cep"
                              @change="getCEP(unidadeData.cep)"
                              mask="#####-###"
                            ></v-text-field>
                            <v-text-field
                              label="Logradouro"
                              v-model="unidadeData.logradouro"
                              ref="rua"
                              :counter="100"
                              maxlength="100"
                            ></v-text-field>
                            <v-text-field
                              label="Número"
                              :counter="10"
                              maxlength="10"
                              v-model="unidadeData.numero"
                            ></v-text-field> 
                            <v-text-field
                              label="Complemento"
                              v-model="unidadeData.complemento"
                              ref="complemento"
                            ></v-text-field>
                            <v-text-field
                              label="Bairro"
                              v-model="unidadeData.bairro"
                              ref="bairro"
                            ></v-text-field> 
                            <v-text-field
                              label="Cidade"
                              v-model="unidadeData.cidade"
                              ref="cidade"
                              :counter="50"
                              maxlength="50"
                            ></v-text-field>
                            <v-text-field
                              label="*E-mail"
                              v-model="unidadeData.email"
                              :rules="emailRules"
                              :counter="50"
                              maxlength="50"
                            ></v-text-field>
                            <v-text-field
                              label="Telefone"
                              v-model="unidadeData.phonenumber"
                              mask="(##) #####-####"
                            ></v-text-field>
                            <v-text-field
                              label="Horario de funcionamento"
                              v-model="unidadeData.horariofunc"
                            ></v-text-field>
                             <v-autocomplete 
                              label="Programas"
                              :items="programas"
                              item-text="slug"
                              item-value="slug"
                              v-model="unidadeData.programa"
                              multiple
                              max-height="400"
                              hint="Escolha o(s) programa(s)"
                              persistent-hint
                            ></v-autocomplete>
                             <v-autocomplete 
                              label="Ano"
                              :items="ano"
                              item-text="name"
                              item-value="name"
                              v-model="unidadeData.ano"
                              multiple
                              max-height="400"
                              hint="Escolha o(s) ano(s)"
                              persistent-hint
                            ></v-autocomplete>
                            <v-autocomplete 
                              label="Responsável"
                              :items="usuario"
                              item-text="username"
                              item-value="username"
                              autocomplete
                              v-model="unidadeData.responsavel"
                              max-height="400"
                              hint="Escolha o usuário"
                              persistent-hint
                            ></v-autocomplete>
                          </v-flex>
                        </v-form>
                      </v-container>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn 
                      color="info"
                      :loading="animation" 
                      @click="performSave" 
                      :disabled="!valid">
                        <v-progress-circular indeterminate color="primary" v-if="loading"></v-progress-circular>
                          <span v-else>
                            Enviar
                          </span>
                          </v-btn>
                  </v-card-actions>
              </v-card>
          </v-flex>
      </v-layout>
</template>

<script>
import api from '@/api'
export default {
  components: {
  },
  data () {
    return {
      unidadeData: {},
      currentTab: 'Sobre',
      showImageUpload: false,
      imageChangeModal: false,
      tipolugar: ['Unidade', 'Escola', 'Licenciada', 'Franquia'],
      editing: false,
      options: [],
      animation: false,
      unidade: [],
      ano: [],
      programas: [],
      empresa: [],
      usuario: [],
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => this.validemail(v)
      ],
      path: '',
      valid: true,
      loading: false
    }
  },
  created () {
    api.request('GET', 'unidade/').then((response) => {
      this.options = response.data
      console.log(response.data)
    })
    api.request('GET', 'programas/').then((response) => {
      this.programas = response.data
    })
    api.request('GET', 'companies/').then(response => {
      this.empresa = response.data
    })
    api.request('GET', 'ano/').then(response => {
      response.data.sort((a, b) => (a.order_number > b.order_number) ? 1 : ((b.order_number > a.order_number) ? -1 : 0))
      this.ano = response.data
    })
  },
  mounted () {
    this.$watch('unidadeData.company', () => {
      api.request('GET', 'users/?company__id=' + this.unidadeData.company + '&groups__name__in=Secretaria%2CAdmin').then((response) => {
        this.usuario = response.data
      })
    })
  },
  computed: {
  },
  methods: {
    goToUnidade (unidade) {
      this.$router.push('/unidade/' + unidade)
    },
    validemail (value) {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value) || 'E-mail inválido'
    },
    performSave () {
      if (this.$refs.form.validate()) {
        this.animation = true
        let self = this
        console.log(self.unidadeData)
        api.request('POST', 'unidade/', self.unidadeData).then(function (response) {
          if (response.data.slug) {
            let name = '/unidades/' + response.data.slug + '/'
            self.animation = false
            self.$router.push(name)
          } else {
            console.log(response)
            self.animation = false
          }
        }).catch(function (error) {
          console.log(error)
          self.animation = false
        })
      }
    },
    clear () {
      this.$refs.form.reset()
    },
    getCEP (valor) {
      var cep = valor.replace(/\D/g, '')

      var xhr = new XMLHttpRequest();
      var url = 'https://viacep.com.br/ws/' + cep + '/json'
      xhr.open('GET', url, true);
      xhr.responseType = 'json';
      xhr.onload = () => {
        var status = xhr.status;
        if (status === 200) {
          this.$refs.rua.value = xhr.response.logradouro
          this.unidadeData.logradouro = xhr.response.logradouro
          this.$refs.cidade.value = xhr.response.localidade
          this.unidadeData.cidade = xhr.response.localidade
          this.$refs.bairro.value = xhr.response.bairro
          this.unidadeData.bairro = xhr.response.bairro
          // this.$refs.estado.value = xhr.response.uf
          // this.unidadeData.estado = xhr.response.uf
          this.$refs.complemento.value = xhr.response.complemento
          this.unidadeData.complemento = xhr.response.complemento
        } else {
          console.log(status)
        }
      };
      xhr.send()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Unidades/Cadastro.vue